import React from 'react'
import { withIcon } from '../../withIcon'

function SortDescIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.375 6C3.375 5.65482 3.65482 5.375 4 5.375H13C13.3452 5.375 13.625 5.65482 13.625 6C13.625 6.34518 13.3452 6.625 13 6.625H4C3.65482 6.625 3.375 6.34518 3.375 6ZM18 5.375C18.3452 5.375 18.625 5.65482 18.625 6V16.4911L20.5581 14.5581C20.8021 14.314 21.1979 14.314 21.4419 14.5581C21.686 14.8021 21.686 15.1979 21.4419 15.4419L18.4419 18.4419C18.1979 18.686 17.8021 18.686 17.5581 18.4419L14.5581 15.4419C14.314 15.1979 14.314 14.8021 14.5581 14.5581C14.8021 14.314 15.1979 14.314 15.4419 14.5581L17.375 16.4911V6C17.375 5.65482 17.6548 5.375 18 5.375ZM3.375 12C3.375 11.6548 3.65482 11.375 4 11.375H11C11.3452 11.375 11.625 11.6548 11.625 12C11.625 12.3452 11.3452 12.625 11 12.625H4C3.65482 12.625 3.375 12.3452 3.375 12ZM3.375 18C3.375 17.6548 3.65482 17.375 4 17.375H11C11.3452 17.375 11.625 17.6548 11.625 18C11.625 18.3452 11.3452 18.625 11 18.625H4C3.65482 18.625 3.375 18.3452 3.375 18Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SortDescIcon)
